import { Text, View } from "@react-pdf/renderer";
import { useNumberFormatter } from "../../../../../hooks";
import type { PDFQuotePubLiabDetails } from "../../../../../lib/types";
import styles from "../styles";

interface Props {
  quoteDetails: {
    lolPremium: PDFQuotePubLiabDetails["lolPremium"];
    stampDuty: PDFQuotePubLiabDetails["stampDuty"];
  };
}

function PubLiabTotals({ quoteDetails }: Props) {
  const { lolPremium, stampDuty } = quoteDetails;

  const moneyFormatter = useNumberFormatter();

  const fields = [
    {
      id: "lolPremium",
      name: "Selected LOL Premium",
      value: lolPremium,
    },
    {
      id: "stampDuty",
      name: "Stamp Duty",
      value: stampDuty,
    },
    {
      id: "grandtT",
      name: "Grand Total",
      value: lolPremium + stampDuty,
      isTotal: true,
    },
  ];

  return (
    <>
      {/* Quotation Totals */}
      <View style={[styles.subSectionHeadingContainer, styles.marginBottom8]}>
        <Text style={[styles.textNormal, styles.textBlue]}>
          Quotation for Public Liability Policy
        </Text>
        <View style={styles.subSectionHeaderLine} />
      </View>

      <View>
        {fields.map(({ id, ...row }) => (
          <View key={id} style={[styles.flexRow, styles.trBorderBottom]}>
            <View style={[styles.flex1, styles.padding8, styles.flexRow]}>
              <Text style={row.isTotal ? styles.thText : styles.tdText}>
                {row.name}
              </Text>
            </View>
            <View
              style={[
                styles.flex1,
                styles.justifyEnd,
                styles.flexRow,
                styles.paddingTop8,
                styles.paddingBottom8,
              ]}
            >
              <Text style={row.isTotal ? styles.thText : styles.tdText}>
                {moneyFormatter.format(row.value)}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </>
  );
}

export default PubLiabTotals;
